module.exports = __webpack_public_path__ + "assets/img/left_4.b7ed3ad3.png";